<template>
  <div class="page--full bg-primary home">
    <el-row type="flex" class="row--full flex-wrap">
      <el-col :sm="12" class="is-flex middle">
        <div>
          <!-- <transition name="fadeInUp"> -->
          <h1 class="home__header" v-if="showContentByPaging">
            <span class="header">We are creating<br />a more connected<br />physical world</span>
          </h1>
          <!-- </transition> -->
          <div class="video-link">
            <a href="#careers" class="text-white text--18 is-demi-bold animating text-none-dec">
              <span class="underline">Watch Our Video</span>
              <img
                class="ml--10"
                src="@/assets/images/icons/next-white.svg"
                alt="Next"
                width="22"
                height="22"
              />
            </a>
          </div>
        </div>
      </el-col>
      <el-col :sm="12" class="is-flex center middle">
        <div class="hero">
          <img src="@/assets/images/hero.gif" alt="Hero" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import contentAnimation from '@/mixins/contentAnimation';

export default {
  name: 'home',
  mixins: [contentAnimation],
};
</script>

<style lang="scss" scoped>
.home {
  padding: 2rem;
  @media (min-width: $sm) {
    padding: 0 10% 0 12%;
  }
  @media (min-width: $xl) {
    padding: 0 10% 0 10%;
  }
  &__header {
    color: $color-white;
    margin-bottom: 2rem;
    padding-top: 2rem;
    @media (min-width: $sm) {
      margin-bottom: 10rem;
      padding-top: 0;
    }
  }
}
.hero {
  img {
    width: auto;
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.7s;
}
.fadeInUp-leave-active {
  animation: fadeInUp 0.7s reverse;
}
</style>
